/* istanbul ignore file */
import { TranslationsNamespaceProvider } from '@ori/i18n';
import { LoggerProvider } from '@ori/logger';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { type FC, Suspense } from 'react';

import { translationsNamespace } from './constants';
import { APP_NAME } from './constants-generated';
import { ApiProvider } from './containers';
import { ErrorBoundary } from './containers/ErrorBoundary';
import { FooterAppSkeleton } from './containers/FooterAppSkeleton';
import { FooterContent } from './containers/FooterContent/FooterContent';
import { AppConfigProvider } from './contexts';
import { mainLogger } from './logger';
import type { AppConfig } from './models';

export interface AppProps {
  configuration: AppConfig;
}

export const App: FC<AppProps> = ({ configuration }) => (
  <LoggerProvider logger={mainLogger}>
    <ErrorBoundary>
      <TranslationsNamespaceProvider namespace={translationsNamespace}>
        <AppConfigProvider value={configuration}>
          <Suspense fallback={<FooterAppSkeleton />}>
            <TestIdProvider
              team={Team.Presentation}
              project={APP_NAME}
            >
              <ApiProvider>
                <FooterContent />
              </ApiProvider>
            </TestIdProvider>
          </Suspense>
        </AppConfigProvider>
      </TranslationsNamespaceProvider>
    </ErrorBoundary>
  </LoggerProvider>
);
